import React from "react";
import { Check, ChevronRight } from "lucide-react";
import { AnimatedSection } from "./AnimatedSection";

interface PricingSectionProps {
  visibleSections: Record<string, boolean>;
}

export const PricingSection: React.FC<PricingSectionProps> = ({
  visibleSections,
}) => {
  const features = [
    {
      title: "Sistema Web Completo",
      desc: "Acesso total para personal trainers",
    },
    {
      title: "App para Alunos",
      desc: "Experiência mobile completa",
    },
    {
      title: "Inteligência Artificial",
      desc: "IA para treinos, avaliações e alimentação",
    },
    {
      title: "Ferramentas Completas",
      desc: "Chat, agenda, anúncios e dashboard",
    },
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 bg-white dark:bg-black transition-colors duration-300">
      <div className="container mx-auto max-w-5xl">
        <AnimatedSection
          id="pricing-header"
          className="text-center mb-12 sm:mb-16"
          visible={visibleSections["pricing-header"] ?? true}
        >
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 sm:mb-6 tracking-tight text-gray-900 dark:text-white">
            Um plano. Tudo incluído.
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-400 font-light">
            Acesso completo a todas as funcionalidades
          </p>
        </AnimatedSection>

        <AnimatedSection
          id="pricing-card"
          delay={200}
          className="relative"
          visible={visibleSections["pricing-card"] ?? true}
        >
          <div className="absolute -inset-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-[3rem] opacity-20 blur-2xl animate-pulse"></div>
          <div className="relative bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/40 dark:to-purple-950/40 backdrop-blur-sm rounded-[2rem] sm:rounded-[2.5rem] p-6 sm:p-12 border border-purple-200 dark:border-purple-500/20 shadow-2xl transition-all duration-500 hover:shadow-purple-500/30">
            <div className="text-center mb-8 sm:mb-12">
              <h3 className="text-3xl sm:text-4xl font-bold mb-2 text-gray-900 dark:text-white">
                Plano Easyfit
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-base sm:text-lg">
                Tudo que você precisa para transformar seus treinos
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
              {features.map((item, i) => (
                <div key={i} className="flex items-start gap-3 sm:gap-4 group">
                  <div className="bg-purple-600/20 dark:bg-purple-500/20 p-2 rounded-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                    <Check className="w-5 sm:w-6 h-5 sm:h-6 text-purple-700 dark:text-purple-400" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-base sm:text-lg mb-1 text-gray-900 dark:text-white">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center">
              <a
                // href="https://pay.hotmart.com/F93284321T"
                href="https://wa.me/5532991112844?text=Ol%C3%A1%21%20Estou%20interessado%20na%20parte%20do%20profissional%20da%20Easyfit."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 sm:px-10 py-3 sm:py-4 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold text-base sm:text-lg rounded-full hover:from-purple-500 hover:to-purple-600 transition-all duration-300 shadow-lg hover:shadow-2xl hover:shadow-purple-500/50 transform hover:scale-105"
              >
                Começar agora
                <ChevronRight className="w-5 h-5" />
              </a>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};
